import TheGrid from '@/views/campaigns/inpar/excluded/grid'
import Edit from '@/views/campaigns/inpar/excluded/edit'

export default {
  path: '/campaigns/inpar/excluded-operators',
  redirect: '/campaigns/inpar/excluded-operators/index',
  name: 'excluded-operators',
  meta: {
    auth: {
      redirect: {
        name: 'excluded-operators.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bónus'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'excluded-operators.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'excluded-operators.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'excluded-operators.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
